// src/App.jsx
import React from "react";
import Navbar from "./components/navigation/Navbar";
import "./components/styles/Style.css";
import Home from "./components/Routes/Home";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Services from "./components/Routes/Services";
import Books from "./components/Routes/Books";
import Projects from "./components/Routes/Projects";
import Achievements from "./components/Routes/Achievements";
import Resume from "./components/Routes/Resume";
import About from "./components/Routes/About";
import { DarkModeProvider } from "./components/context/DarkModeContext";
import { LangDialogueboxProvider } from "./components/context/LanguageContext";
import { FilterDialogueBoxProvider } from "./components/context/FilterContext";
import ServicesDetails from "./components/contents/ServicesDetails";
import { CertDialogueContextProvider } from "./components/context/CertDialogueContext";

import Menifesto from "./components/Routes/Menifesto";
import { PDialogueBoxProvider } from "./components/context/PDialogueBoxContext";
import Footer from "./Footer/Footer";
import AdminPage from "./Blog/pages/AdminPage";
import PublicDetail from "./Blog/pages/PublicDetail";
import PublicList from "./Blog/pages/PList";
import { AlertBoxContextProvider } from "./utils/AlertBox";
import Form from "./components/contents/Form";
import Login from "./components/Authentication/pages/Login";
import Signup from "./components/Authentication/pages/Signup";
import Profile from "./components/Authentication/pages/Profile";
import ProtectedRoute from "./components/Authentication/routes/ProtectedRoute";
import PublicOnlyRoute from "./components/Authentication/routes/PublicOnlyRoute";
import { AuthProvider } from "./components/Authentication/context/authContext";

const App = () => {


  return (
    <AuthProvider>
    <BrowserRouter>
      <DarkModeProvider>
        <LangDialogueboxProvider>
          <PDialogueBoxProvider>
            <FilterDialogueBoxProvider>
              <CertDialogueContextProvider>
                <AlertBoxContextProvider>
                  <Navbar />
                  <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Home />} />
                    <Route
                      path="/login"
                      element={
                        <PublicOnlyRoute>
                          <Login />
                        </PublicOnlyRoute>
                      }
                    />
                    <Route
                      path="/signup"
                      element={
                        <PublicOnlyRoute>
                          <Signup />
                        </PublicOnlyRoute>
                      }
                    />
                    <Route
                      path="/profile"
                      element={
                        <ProtectedRoute>
                          <Profile />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/services" element={<Services />} />
                    <Route path="/services/:id" element={<ServicesDetails />} />
                    <Route path="/books" element={<Books />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/blogs" element={<PublicList />} />
                    <Route path="/blog/:id" element={<PublicDetail />} />
                    <Route path="/fordev" element={<AdminPage />} />
                    <Route path="/booknow" element={<Form />} />

                    {/* Protected routes */}
                      <Route path="/manifesto" element={<ProtectedRoute><Menifesto /></ProtectedRoute>} />
                      <Route path="/resume" element={<ProtectedRoute><Resume /></ProtectedRoute>} />
                      <Route path="/achievements" element={<ProtectedRoute><Achievements /></ProtectedRoute>} />

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </AlertBoxContextProvider>
                <Footer />
              </CertDialogueContextProvider>
            </FilterDialogueBoxProvider>
          </PDialogueBoxProvider>
        </LangDialogueboxProvider>
      </DarkModeProvider>
    </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
